module.exports = __webpack_public_path__ + "static/blizzard-44bf64de2b9bfb8c12365afb53f1bddd.svg";